/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './watermark.component';
const styles_WatermarkComponent:any[] = ([] as any[]);
export const RenderType_WatermarkComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_WatermarkComponent,
  data: {}
}
);
export function View_WatermarkComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'watermark'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n    ',
      '\n'
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(ck,v) => {
    var co:import1.WatermarkComponent = v.component;
    const currVal_0:any = co.text;
    ck(v,1,0,currVal_0);
  });
}
function View_WatermarkComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-watermark',([] as any[]),(null as any),(null as any),(null as any),View_WatermarkComponent_0,RenderType_WatermarkComponent)),
    import0.ɵdid(49152,(null as any),0,import1.WatermarkComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const WatermarkComponentNgFactory:import0.ComponentFactory<import1.WatermarkComponent> = import0.ɵccf('woa-watermark',import1.WatermarkComponent,View_WatermarkComponent_Host_0,{text: 'text'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvd2F0ZXJtYXJrL3dhdGVybWFyay5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC91aS1lbGVtZW50cy93YXRlcm1hcmsvd2F0ZXJtYXJrLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvd2F0ZXJtYXJrL3dhdGVybWFyay5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvd2F0ZXJtYXJrL3dhdGVybWFyay5jb21wb25lbnQudHMuV2F0ZXJtYXJrQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cIndhdGVybWFya1wiPlxuICAgIHt7dGV4dH19XG48L2Rpdj5cbiIsIjx3b2Etd2F0ZXJtYXJrPjwvd29hLXdhdGVybWFyaz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF1QjtNQUFBO01BQUE7SUFBQTtJQUFBO0lBRWpCOzs7O0lBRmlCO0lBQUE7Ozs7O0lDQXZCO2dCQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/app/ui-elements/watermark/watermark.component.ngfactory.ts